import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dv6f48qrzb: FaireBrandEntity = {
  token: "b_dv6f48qrzb",
  type: "brand",
  name: "She's The Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/aee2d5a0cf5699c55153bdc570c2804e8d9d4286a87f5c640da58111aa786b8b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ee2454153143731a2cee737f49754f23c88e9a8571db91da59fa5b8699415941.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aee2d5a0cf5699c55153bdc570c2804e8d9d4286a87f5c640da58111aa786b8b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ee2454153143731a2cee737f49754f23c88e9a8571db91da59fa5b8699415941.jpeg",
  location: "10003, NY, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    'Our founder always had a thing for sauce ever since she was a kid, obsessed with putting Heinz ketchup on everything. But as she got older and started struggling with weight and bloating from food sensitivities and hormonal imbalances, she kept hearing one thing over and over again:\n\n"Skip the sauce"\n"It\'s just empty calories."\n"It\'s not good for you."\n\nAnd as a sauce-obsessed girlie who believes no meal is complete without sauce? That just never sat right with her. So after 5+ years of working in food and beverage marketing for brands at Uber, Walmart, and Gopuff, she decided it was time to launch my own sauce line with none of the junk and all of the flavor. \n\nThat’s when She’s the Sauce was born.\n\nWith She’s the Sauce, you can say goodbye to reigning in your saucy habits because these condiments are made from clean ingredients, packed with protein, and filled with fiber. \n\nIt’s about damn time your favorite sauces got upgraded to delicious and nutritious.',
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:07.142Z",
    importedBy: "entity-db-cli",
  },
};
